<script setup lang="ts">
import { useLogger } from 'vue-logger-plugin'
import {
  GetCartItemCount,
  GetCurrentCartIdentifiers,
  CartLocalStorageKey,
  PayeeAddToCart
} from '@/services/CartService'
import { ref, onMounted } from 'vue'
import { setStoreLogger } from '@/logger.ts'
import {
  GetCartDetailUrl,
  GetBeeNumberAuthenicatedUser,
  GetBeeNumberSite
} from '@/stores/SettingsStore.ts'
import type { IAoeCart } from '@/types/CartTypes.ts'
import { GetCartFromLocalStorage, CustomerAddToCart } from '@/services/CartService.ts'
import { useCookies } from 'vue3-cookies'

const logger = useLogger()
setStoreLogger(logger)
logger.debug('AOECartImageButton.vue')
const cart = ref<IAoeCart | null>(null)
const cartQuantity = ref(0)
const cartIdentifiers = GetCurrentCartIdentifiers()
const { cookies } = useCookies()

const cartDetailUrl = ref<string>('')

async function storageHandler(event: StorageEvent) {
  logger.debug('storageHandler FIRED - event.key:', event.key, 'CartLocalStorageKey:', CartLocalStorageKey)
  
  // Only process cart events to avoid spam
  if (event.key !== CartLocalStorageKey) {
    return
  }
  
  logger.debug('storageHandler - CART EVENT DETECTED, processing...')
  const cartIdentifiers = GetCurrentCartIdentifiers()
  logger.debug('storageHandler - cartIdentifiers:', cartIdentifiers)
  
  if (cartIdentifiers) {
    logger.debug('storageHandler - cartIdentifiers exists, calling GetCartItemCount with token:', cartIdentifiers.aoeCartIdToken)
    cartQuantity.value = await GetCartItemCount(cartIdentifiers.aoeCartIdToken)
    logger.debug('storageHandler - updated cartQuantity to:', cartQuantity.value)
  }
  else
  {
    logger.debug('storageHandler - NO cartIdentifiers, setting cartQuantity to 0')
    cartQuantity.value = 0;
  }
}

function cartClickedHandler() {
  logger.debug('cartClickedHandler')
  window.location.href = cartDetailUrl.value
}

window.addEventListener('storage', storageHandler, false)

onMounted(async () => {
  cartDetailUrl.value = await GetCartDetailUrl()
  if (cartIdentifiers) {
    cartQuantity.value = await GetCartItemCount(cartIdentifiers.aoeCartIdToken)

    // //check if customer logged in, then check if cart has customer, if not add customer to cart
    // const beeNumberAuthenicatedUser = await GetBeeNumberAuthenicatedUser()
    // const beeNumberSite = await GetBeeNumberSite()
    // if (beeNumberAuthenicatedUser) {
    //   cart.value = await GetCartFromLocalStorage(cartIdentifiers.aoeCartIdToken)
    //   if (cart.value && (cart.value.beeBusinessGuidCustomer == null || cart.value.beeBusinessGuidCustomer == undefined)) {
    //     await CustomerAddToCart({
    //       aoeCartIdToken: cartIdentifiers.aoeCartIdToken,
    //       beeNumberCustomer: beeNumberAuthenicatedUser
    //     });
    //   }
    // }

    // if (beeNumberSite) {
    //   cart.value = await GetCartFromLocalStorage(cartIdentifiers.aoeCartIdToken)
    //   if (cart.value && (cart.value.beeNumberPayee == null || cart.value.beeNumberPayee == undefined || cart.value.beeNumberPayee != beeNumberSite)) {
    //     await PayeeAddToCart({
    //       aoeCartIdToken: cartIdentifiers.aoeCartIdToken,
    //       beeNumberPayee: beeNumberSite
    //     }).then(() => {
    //       cookies.set('ReplicatedSiteBeeNumber', beeNumberSite.toString());
    //       window.location.href = window.location.href
    //     });
    //   }
    // }
  }
  else
  {
    cartQuantity.value = 0;
  }
})
</script>
<template>
  <div style="position: relative; height: 30px; width: 30px">
    <button
      @click="cartClickedHandler"
      class="cart-icon-button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M5 5
         L19 5
         L20 21
         L4 21
         Z"></path>

<path d="M8 8 V6 C8 3 10 1 12 1 C14 1 16 3 16 6 V8"></path>
      </svg>
    </button>

    <div
      v-if="cartQuantity > 0"
      class="cart-badge"
    >
      {{ cartQuantity }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cart-icon-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  width: 30px;
  height: 30px;
}

.cart-icon-button:hover {
  opacity: 0.7;
}

.cart-badge {
  position: absolute;
  top: -2px;
  right: -5px;
  background-color: #e74c3c;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}
</style>
